import { createSlice } from "@reduxjs/toolkit";

const initialState = {
        settings: {
        "website-title":"",
        "website-subtitle":"",
        "colours":{
            primary: "#008F8F",
            secondary: "#1f2937", // gray-800
            disabled: "#b5CFCF",
            bodyColor: "#111827", // gray-900
            danger: "#fee2e2", // red-100
            success: "#dcfce7", // green-100
        },
        "header":{
            "img":""
        }
    }
};

const websiteSettingsSlice = createSlice({
	name: "settings",
	initialState,
	reducers: {
		setSettings(state, action) {
			state.settings = {...action.payload};
            console.log(action.payload)
            const {
                primary,
                secondary,
                bodyColor,
                danger,
                success,
                disabled
            } = (action.payload?.colours||{});
            document.documentElement.style.setProperty('--primary', primary);
            document.documentElement.style.setProperty('--secondary', secondary);
            document.documentElement.style.setProperty('--bodyColor', bodyColor);
            document.documentElement.style.setProperty('--danger', danger);
            document.documentElement.style.setProperty('--success', success);
            document.documentElement.style.setProperty('--disabled', disabled);
            
		}
	},
});

export const websiteSettingsActions = websiteSettingsSlice.actions;
export default websiteSettingsSlice;
